import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../service/api/auth/auth.service';
import { environment } from 'src/environments/environment';

const AUTHENTICATED_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.authService.getToken();
    if (
      token &&
      AUTHENTICATED_METHODS.includes(request.method) &&
      request.url.startsWith(environment.API_BASE_URL)
    ) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }
    return next.handle(request);
  }
}
